export default __webpack_public_path__ + "static/media/water.042cf36b.png";